import React, {useState, useEffect} from 'react';
import classnames from 'classnames';
import ReactSVG from 'react-svg';

let animationTimeout;

const Header = ({className, processingNavigation}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const cssBem = "header";
  const classes = classnames(
    cssBem,
    className
  );

  useEffect(() => {
    if(processingNavigation){
      setIsLoading(true)
    }else{
      clearTimeout(animationTimeout);
      animationTimeout = setTimeout(() => setIsLoading(false), 1250 );
    }
  }, [processingNavigation]);

  return <>
    <header className={classes}>
      <div className="container">
        <div className={`${cssBem}__logo`}>
          <ReactSVG src="/classpath/assets/images/logo.svg" />
        </div>
        { isLoading ? <div className={`${cssBem}__loading`}> <ReactSVG src="/classpath/assets/images/loading.svg" /></div> : null }
      </div>
    </header>
  </>;
};

export default Header;
